import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { RegistraionTypes, countryList } from '../../../../utils/constants/utility';
import { createConfigArray } from '../../../../utils/default-configs/configuration';
import { configurationIdMapForTaxSetting } from '../../../../utils/constants/constant';

@Component({
  selector: 'app-taxsetting',
  templateUrl: './taxsetting.component.html',
  styleUrls: ['./taxsetting.component.scss'],
})
export class TaxSettingComponent implements OnInit, AfterViewInit {
  configReceiver: any;
  configImported: any;
  shipperRegistraionTypes;
  shipperTaxSetting: FormGroup;
  ShipperDataSource = new MatTableDataSource<any>();
  ShipperData: any;
  isValueChanged: boolean = false;
  list = [];

  columns: string[] = [
    'number',
    'shipperRegistrationType',
    'shipperRegistrationNumber',
    'shipperIssuingCountryCode',
    'Action',
  ];
  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService
  ) {}

  ngOnInit(): void {
    this.shipperTaxSetting = this.fb.group({
      _id: '',
      config_id: '',
      customer_id: '',
      updated_by_username: '',
      updated_time: '',
      data: this.fb.array([]),
    });
    this.shipperRegistraionTypes = RegistraionTypes;
    this.list = countryList;
    this.getDefaultConfiguration();
  }

  getDefaultConfiguration() {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForTaxSetting))
      .then(response => {
        response.forEach(item => {
          this.patchValueToFormsInTaxSetting(item?.config_id, item?.data);
        });
      });
  }

  patchValueToFormsInTaxSetting(formName, formData) {
    const formConfigs = {
      default: () => ``,
      importer_tax_setting: () => (this.configImported = formData),
      receiver_tax_setting: () => (this.configReceiver = formData),
      shipper_tax_setting: () => {
        this.shipperTaxSetting.patchValue(formData);
        this.ShipperData = formData;
        const ShipperArray = formData;
        (this.shipperTaxSetting.get('data') as FormArray).clear();
        ShipperArray.forEach(item => {
          const ShipperGrp = this.addShipperGroup();
          ShipperGrp.patchValue(item);
          (this.shipperTaxSetting.get('data') as FormArray).push(ShipperGrp);
        });
        this.ShipperDataSource = new MatTableDataSource(
          (this.shipperTaxSetting.get('data') as FormArray).controls
        );
      },
    };
    return (formConfigs[formName] || formConfigs.default)();
  }

  AddNewShipperItem() {
    const control = this.shipperTaxSetting.get('data') as FormArray;
    control.insert(
      (this.shipperTaxSetting.get('data') as FormArray).controls.length + 1,
      this.addShipperGroup()
    );
    this.ShipperDataSource = new MatTableDataSource(control.controls);
  }

  DeleteShipperItem(_formElement, i) {
    const control = this.shipperTaxSetting.get('data') as FormArray;
    control.removeAt(i);
    this.ShipperDataSource = new MatTableDataSource(
      (this.shipperTaxSetting.get('data') as FormArray).controls
    );
  }

  private addShipperGroup(): FormGroup {
    return this.fb.group({
      shipperRegistrationType: new FormControl('', Validators.compose([Validators.required])),
      shipperRegistrationNumber: new FormControl('', Validators.compose([Validators.required])),
      shipperIssuingCountryCode: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  getShipperFormControlId(id, control) {
    return (this.shipperTaxSetting.get('data') as FormArray).controls[id].get(control);
  }

  saveShipperConfig() {
    const config = this.shipperTaxSetting.value;
    config.config_id = 'shipper_tax_setting';

    this.configService.saveConfig(config).subscribe(() => {
      this.errorDialogService.openDialog('alert.configurationSuccess', false);
      this.isValueChanged = false;
      this.configService.putConfig(config.config_id, config.data);
    });
  }

  ngAfterViewInit() {
    this.isAnyValueUnChanged();
  }

  isAnyValueUnChanged() {
    setTimeout(() => {
      setTimeout(
        function () {
          this.shipperTaxSetting.valueChanges.subscribe(() => {
            this.isValueChanged = true;
          });
        }.bind(this),
        0
      );
    }, 1000);
  }
}
